import type { TransmissionType } from '../types/vehicle.types'

export type MarketTransmissionType = Extract<TransmissionType, 'automatic' | 'manual'>

export const MARKET_TRANSMISSIONS: MarketTransmissionType[] = ['automatic', 'manual']

export function toMarketTransmission(
  transmission: TransmissionType | null | undefined,
): MarketTransmissionType | null {
  if (!transmission) return null
  return transmission === 'manual' ? 'manual' : 'automatic'
}

export function marketTransmissionI18nKey(
  namespace: 'listing.transmissions' | 'explore.transmission',
  transmission: TransmissionType | null | undefined,
): string | null {
  const marketTransmission = toMarketTransmission(transmission)
  return marketTransmission ? `${namespace}.${marketTransmission}` : null
}

export function formatMarketTransmissionText(value: string | null | undefined): string {
  if (!value) return ''
  return value.replace(/\b(CVT|DCT)\b/gi, 'Automático')
}
